import React, { useState } from 'react';

import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import HeightQuestion from 'on_web/components/shared/HeightQuestion/HeightQuestion';
import WeightQuestion from 'on_web/components/shared/WeightQuestion/WeightQuestion';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import SectionTitle from 'on_web/components/shared/Common/SectionTitle';
import { weightAndHeight } from 'on_web/assets/imageList';
import { Box } from '@material-ui/core';
import UserProfileContext from 'on_web/context/userProfileContext';
import {
  lbsToKg,
  convertFtAndInToCm,
  getUserWeight,
  getUserHeight,
  getUserHeight2,
} from 'on_web/helpers/converterHelper';
import { getWeightMetrics, getHeightMetrics } from 'on_web/helpers/questions';

import { useTranslation } from 'react-i18next';
export default function GeneralStep2(props) {
  const context = React.useContext(UserProfileContext);

  const [weight, setWeight] = useState(
    context &&
      context.userProfile &&
      context.userProfile.weight &&
      context.userMetaData &&
      context.userMetaData.user_metadata
      ? getUserWeight(
          context.userProfile.weight,
          context.userMetaData.user_metadata.selectedWeightMetric
        )
      : 0
  );
  const [height, setHeight] = useState(
    context &&
      context.userProfile &&
      context.userProfile.height &&
      context.userMetaData &&
      context.userMetaData.user_metadata
      ? getUserHeight(
          context.userProfile.height,
          context.userMetaData.user_metadata.selectedHeightMetric
        )
      : 0
  );
  const [height2, setHeight2] = useState(
    context &&
      context.userProfile &&
      context.userProfile.height &&
      context.userMetaData &&
      context.userMetaData.user_metadata
      ? getUserHeight2(
          context.userProfile.height,
          context.userMetaData.user_metadata.selectedHeightMetric
        )
      : 0
  );
  const [selectedWeightMetric, setSelectedWeightMetric] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.user_metadata.selectedWeightMetric
      ? context.userMetaData.user_metadata.selectedWeightMetric
      : 0
  );
  const [selectedHeightMetric, setSelectedHeightMetric] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.user_metadata.selectedHeightMetric
      ? context.userMetaData.user_metadata.selectedHeightMetric
      : 0
  );

  const { t } = useTranslation();

  const weightMetrics = getWeightMetrics(t);

  const heightMetrics = getHeightMetrics(t);

  const isValidInput = () => {
    if (weight == null) {
      return false;
    }

    if (
      weight < weightMetrics[selectedWeightMetric].minValue ||
      weight > weightMetrics[selectedWeightMetric].maxValue
    ) {
      return false;
    }

    if (selectedHeightMetric === 0) {
      if (height == null) {
        return false;
      }

      if (
        height < heightMetrics[selectedHeightMetric].minValues[0] ||
        height > heightMetrics[selectedHeightMetric].maxValues[0]
      ) {
        return false;
      }
    } else {
      if (height == null || height2 == null) {
        return false;
      }

      if (
        height < heightMetrics[selectedHeightMetric].minValues[0] ||
        height2 < heightMetrics[selectedHeightMetric].minValues[1] ||
        height > heightMetrics[selectedHeightMetric].maxValues[0] ||
        height2 > heightMetrics[selectedHeightMetric].maxValues[1]
      ) {
        return false;
      }
    }

    return true;
  };

  const onClickNext = () => {
    const userProfile = context ? context.userProfile : null;
    const userMetaData = context ? context.userMetaData.user_metadata : null;

    if (props.onClickNext && userProfile && userMetaData) {
      const weightToSave =
        selectedWeightMetric === 0 ? lbsToKg(weight) : weight;
      userProfile.weight = weightToSave;
      const heightToSave =
        selectedHeightMetric === 0
          ? convertFtAndInToCm(height, height2)
          : height;
      userProfile.height = heightToSave;
      userMetaData.selectedWeightMetric = selectedWeightMetric;
      userMetaData.selectedHeightMetric = selectedHeightMetric;
      props.onClickNext(userMetaData, userProfile);
    }
  };

  return (
    <React.Fragment>
      <Header />
      {context && context.forPce ? (
        <PceStepProgressIndicator selectedSlideIx={1} />
      ) : (
        (context == null || context.editMode !== true) && (
          <StepProgressIndicator
            showBasicQuestions={context.showBasicQuestions}
            selectedSlideIx={
              process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 1 : 0
            }
          />
        )
      )}

      <SectionTitle
        text={t('onboarding.generalSection.generalStep2.sectionTitle1')}
      />
      <Box
        px={{ xs: 2, sm: 3, md: 4 }}
        justifyContent="center"
        display="flex"
        style={{ marginTop: '21px', marginBottom: '25px' }}
      >
        <img src={weightAndHeight} alt="weight and height illustration" />
      </Box>

      <WeightQuestion
        value={weight}
        selectedMetricIx={selectedWeightMetric}
        text={t('onboarding.generalSection.generalStep2.weight')}
        metrics={weightMetrics}
        onAnswer={(val, metricIx) => {
          setWeight(val);
          setSelectedWeightMetric(metricIx);
        }}
        autoFocus
      />
      <Box style={{ marginTop: '34.5px' }}>
        <HeightQuestion
          value={height}
          value2={height2}
          selectedMetricIx={selectedHeightMetric}
          text={t('onboarding.generalSection.generalStep2.height')}
          metrics={heightMetrics}
          onAnswer={(val, val2, metricIx) => {
            setHeight(val);
            setHeight2(val2);
            setSelectedHeightMetric(metricIx);
          }}
        />
      </Box>

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={!isValidInput()}
        editMode={context && context.editMode}
      />
    </React.Fragment>
  );
}
